// eslint-disable-next-line import/prefer-default-export
export const categories = {
  DIRECT : 'direct',
  INDIRECT : 'indirect',
  INDIRECT_OTHER : 'indirectOther',
  UNCATEGORIZED : 'uncategorized',
}
